<div class="bg-dash">

    <div class="page-padding">
        <div class="page-header-custom">
            <h1 class="page-title">{{ 'dashboard'|translate }}</h1>
        </div>

        <div class="page-filter">
            <div class="input-material">
                <select id="campaign" class="form-control" name="type" [(ngModel)]="filter.evaluation">
                    <option *ngFor="let e of evaluations" [ngValue]="e.id">{{ e.name }}</option>
                </select>
                <label for="campaign" class="mb-0 mr-3">{{ 'campanha'|translate }}</label>
            </div>
            <div class="input-material">
                <select id="unity" class="form-control" name="type" [(ngModel)]="filter.unity">
                    <option [ngValue]="undefined">Todos</option>
                    <option *ngFor="let e of allUnities" [ngValue]="e.id">{{ e.name }}</option>
                </select>
                <label for="unity" class="mb-0 mr-3">Unidade</label>
            </div>

            <div class="input-material">
                <ng-multiselect-dropdown
                        [settings]="dropSettings"
                        [(ngModel)]="filter.costCenter"
                        [data]="userCostCenter.costCenter"
                        [placeholder]="'buscar' | translate">
                </ng-multiselect-dropdown>

                <label class="mb-0 mr-3 disabled">{{ 'centrocusto' | translate }}</label>
            </div>

            <app-date-picker (selectDate)="selectedDate($event)" [start]="this.filter.start"
                             [end]="this.filter.end"></app-date-picker>
                             
            <a (click)="onFilter()" class="btn btn-primary btn-lg text-white">{{ 'buscar'|translate }}</a>
        </div>
        <div class="dashboard">
            <h3>Avaliação</h3>

            <div class="dash-card">
                <div class="row">
                    <div class="col-md-6">
                        <h4>Visão Geral</h4>
                        <span>Entenda o volume gerado pela campanha {{ findElevation(evaluationSelected) }}</span>
                        <ng-container *ngIf="!isNullOrUndefined(this.evaluationOverviewDashboard.overall)">
                            <google-chart style="width: 100%;height: 300px;" [type]="'PieChart'"
                                          [options]="dashboardPieOptions"
                                          [columns]="evaluationOverviewColumn"
                                          [data]="evaluationOverviewGraph"></google-chart>
                        </ng-container>
                    </div>
                    <div class="col-md-6">
                        <h4>Por unidade</h4>
                        <ng-container *ngIf="!isNullOrUndefined(this.evaluationOverviewDashboard.byUnity)">
                            <google-chart style="width: 100%;height: 300px;" [type]="'ColumnChart'"
                                          [options]="dashboardUnityOptions"
                                          [columns]="evaluationUnityColumn"
                                          [data]="evaluationUnityGraph"></google-chart>
                        </ng-container>
                        <div *ngIf="isNullOrUndefined(this.evaluationOverviewDashboard.byUnity)">
                            <p class="text-center py-5 mb-0">Nenhuma informação encontrada</p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row mt-4">
                <div class="col-md-9">
                    <h3>Média das avaliações de desempenho</h3>
                </div>
                <div class="col-md-3">
                    <h3>Acompanhamento PDI</h3>
                </div>
            </div>


            <div class="mb-4">
                <div class="row">
                    <div class="col-md-9">
                        <div class="dash-card">
                            <p class="text-center py-5"
                               *ngIf="isNullOrUndefined(competencePerformanceAverageDashboard)">
                                {{ 'noRecordFound' | translate }}
                            </p>
                            <table *ngIf="!isNullOrUndefined(competencePerformanceAverageDashboard)"
                                   class="w-100 dashboard_table">
                                <tr>
                                    <th></th>
                                    <th class="text-center">Geral</th>
                                    <th class="text-center">Por centro de custo</th>
                                </tr>
                                <tr *ngFor="let x of competencePerformanceAverageDashboard">
                                    <td>{{ x.competenceName }}</td>
                                    <td class="text-center">{{ x.companyAverage }}</td>
                                    <td class="text-center">{{ x.costCenterAverage != null ? x.costCenterAverage : '-' }}</td>
                                </tr>
                            </table>
                            <div class="d-flex mt-5" style="gap: 25px">
                                <div class="d-flex align-items-center" style="gap: 5px">
                                    <div class="dashboard_card" style="background-color: #25acbe">1</div>
                                    <span>Não Apresenta</span>
                                </div>
                                <div class="d-flex align-items-center" style="gap: 5px">
                                    <div class="dashboard_card" style="background-color: #1f9ffa">2</div>
                                    <span>Necessita desenvolvimento</span>
                                </div>
                                <div class="d-flex align-items-center" style="gap: 5px">
                                    <div class="dashboard_card" style="background-color: #276ae8">3</div>
                                    <span>Atende expectativa</span>
                                </div>
                                <div class="d-flex align-items-center" style="gap: 5px">
                                    <div class="dashboard_card" style="background-color: #2bbe7e">4</div>
                                    <span>Supera expectativa</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="dash-card">
                            <h4>Status do PDI</h4>
                            <ng-container *ngIf="!isNullOrUndefined(this.pdiFollowUpDashboard.pdiStatus)">
                                <google-chart style="width: 100%;height: 300px;" [type]="'PieChart'"
                                              [options]="dashboardPieOptions"
                                              [columns]="pdiFollowUpColumn"
                                              [data]="pdiFollowUpGraph"></google-chart>
                            </ng-container>
                            <div *ngIf="isNullOrUndefined(this.pdiFollowUpDashboard.pdiStatus)">
                                <p class="text-center mb-0">Nenhuma informação encontrada</p>
                            </div>
                            <p class="font-weight-bold mb-3">Média de realizações das tarefas</p>
                            <div class="px-3">
                                <div class="dashboard_bar">
                                    <div class="dashboard_bar-secondary"
                                         [ngStyle]="{'width':this.pdiFollowUpDashboard.tasksAveragePercent + '%'}">
                                        <p style="min-width: 39px"
                                           [ngClass]="this.pdiFollowUpDashboard.tasksAveragePercent > 85 ?'translate-x-0':'translate-x-100'">{{ this.pdiFollowUpDashboard.tasksAveragePercent }}
                                            %</p>
                                    </div>
                                </div>
                                <div class="d-flex justify-content-between">
                                    <span style="font-size: 13px">0</span>
                                    <span style="font-size: 13px">50</span>
                                    <span style="font-size: 13px">100</span>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-md-12">
                    <h3>Feedbacks</h3>
                    <div class="dash-card">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="dash-card bgDash mb-4">
                                    <h4>Quantidade de feedbacks</h4>
                                    <p class="mb-3">A média necessária para a realização do feedbacks Mensal é
                                        <strong>{{ this.feedbackQtdDashboard.teamSize }}
                                            usuários</strong></p>
                                    <div class="d-flex align-items-center" style="gap: 25px">
                                        <div class="flex-grow-0">
                                            <div style="min-width: 149px;padding: 40px 20px;"
                                                 class="dash-card d-flex align-items-center flex-column">
                                                <span style="font-size: 24px;font-weight: bold">{{ this.feedbackQtdDashboard.accumulatedPercent }}
                                                    %</span>
                                                <span>{{ this.feedbackQtdDashboard.accumulatedCount }}</span>
                                                <span style="font-size: 11px"
                                                      class="text-center">Acumulado de {{ this.feedbackQtdDashboard.year }}</span>
                                            </div>
                                        </div>
                                        <div class="flex-grow-1">
                                            <ng-container *ngIf="!isNullOrUndefined(this.feedbackQtdDashboard.months)">
                                                <google-chart style="width: 100%;height: 300px;" [type]="'ColumnChart'"
                                                              [options]="dashboardFeedBackOptions"
                                                              [columns]="feedbackColumn"
                                                              [data]="feedbackGraph"></google-chart>
                                            </ng-container>
                                            <div *ngIf="isNullOrUndefined(this.feedbackQtdDashboard.months)">
                                                <p class="text-center mb-0">Nenhuma informação encontrada</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="dash-card bgDash mb-4">
                                    <h4>Unidades</h4>
                                    <ng-container *ngIf="!isNullOrUndefined(this.unityDashboard.graph)">
                                        <google-chart style="width: 100%;height: 300px;" [type]="'ColumnChart'"
                                                      [options]="dashboardOptions"
                                                      [columns]="unityDashboardColumn"
                                                      [data]="unityDashboardGraph"></google-chart>
                                        <div class="p-3">
                                            <div class="row no-wrap legend-row top justify-content-between">
                                                <p>Nome Unidade</p>
                                                <p>Total</p>
                                            </div>
                                            <ng-container *ngFor="let x of unityDashboard.dashboard">
                                                <div class="row no-wrap legend-row align-items-center justify-content-between">
                                                    <div class="d-flex align-items-center">
                                                        <div class="square"
                                                             [ngStyle]="{'background-color': x.color}"></div>
                                                        <p>{{ x.name }}</p>
                                                    </div>
                                                    <p>{{ x.count }}</p>
                                                </div>
                                            </ng-container>
                                        </div>
                                    </ng-container>
                                    <div *ngIf="isNullOrUndefined(this.unityDashboard.graph)">
                                        <p class="text-center mb-0">Nenhuma informação encontrada</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="dash-card bgDash mb-4">
                                    <h4>Área</h4>
                                    <ng-container *ngIf="!isNullOrUndefined(this.areaDashboard.graph)">
                                        <google-chart style="width: 100%;height: 300px;" [type]="'ColumnChart'"
                                                      [options]="dashboardOptions"
                                                      [columns]="areaDashboardColumn"
                                                      [data]="areaDashboardGraph"></google-chart>
                                        <div class="p-3">
                                            <div class="row no-wrap legend-row top justify-content-between">
                                                <p>Nome Área</p>
                                                <p>Total</p>
                                            </div>
                                            <ng-container *ngFor="let x of areaDashboard.dashboard">
                                                <div class="row no-wrap legend-row align-items-center justify-content-between">
                                                    <div class="d-flex align-items-center">
                                                        <div class="square"
                                                             [ngStyle]="{'background-color': x.color}"></div>
                                                        <p>{{ x.name }}</p>
                                                    </div>
                                                    <p>{{ x.count }}</p>
                                                </div>
                                            </ng-container>
                                        </div>
                                    </ng-container>
                                    <div *ngIf="isNullOrUndefined(this.areaDashboard.graph)">
                                        <p class="text-center mb-0">Nenhuma informação encontrada</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="dash-card bgDash">
                                    <h4>Último Feedback registrado a mais de 4 meses</h4>
                                    <div class="table-responsive">
                                        <table class="table">
                                            <thead>
                                            <tr>
                                                <th scope="col">Colaborador</th>
                                                <th scope="col" class="text-center">QTD Mês</th>
                                                <th scope="col" class="text-center">Último feedback</th>
                                                <th scope="col" class="text-center">Último feedback</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr>
                                                <td *ngIf="isNullOrUndefined(feedbackLateDashboard.results)"
                                                    class="text-center" colspan="4">
                                                    {{ "noRecordFound" | translate }}
                                                </td>
                                            </tr>
                                            <tr *ngFor="let x of feedbackLateDashboard.results |
                                            paginate: {itemsPerPage: feedbackLateDashboard.pageSize,
                                            currentPage: feedbackLateDashboard.currentPage,
                                            totalItems: feedbackLateDashboard.totalCount}">
                                                <td>{{ x.name }}</td>
                                                <td class="text-center">{{ x.monthCount }}</td>
                                                <td class="text-center">{{ x.lastFeedbackAt != null ? (x.lastFeedbackAt | date:'dd/MM/yyyy') : '-' }}</td>
                                                <td class="text-center">
                                                    <a href="javascript:void('');"
                                                       [routerLink]="'/avaliation/history/' + x.userId">
                                                        <svg-icon src="assets/svg/eye.svg"></svg-icon>
                                                    </a>
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div class="text-right">
                                        <pagination-controls
                                                [previousLabel]="labels.previousLabel"
                                                [nextLabel]="labels.nextLabel"
                                                [screenReaderPaginationLabel]="labels.screenReaderPaginationLabel"
                                                [screenReaderPageLabel]="labels.screenReaderPageLabel"
                                                [screenReaderCurrentLabel]="labels.screenReaderCurrentLabel"
                                                (pageChange)="pageChanged($event)"></pagination-controls>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


        </div>
    </div>
</div>




